import React, { useEffect, useState } from "react";
import { Save } from "lucide-react";
import { api, fmtErr } from "../../lib/api";
import { useSite } from "../../context/AppContext";
import { toast } from "sonner";

const inputCls = "w-full rounded-lg border border-slate-300 px-3 py-2 text-sm text-slate-800 focus:border-amber-500 bg-white";

export default function AdminContactInfo() {
  const { site, refreshSite } = useSite();
  const [c, setC] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (site?.contact) setC({ ...site.contact });
  }, [site]);

  if (!c) return <div className="py-16 flex justify-center"><div className="w-8 h-8 border-2 border-amber-500/30 border-t-amber-600 rounded-full animate-spin" /></div>;

  const save = async () => {
    setSaving(true);
    try {
      await api.put("/admin/site", { contact: c });
      await refreshSite();
      toast.success("Contact information saved");
    } catch (e) {
      toast.error(fmtErr(e));
    } finally {
      setSaving(false);
    }
  };

  return (
    <div data-testid="admin-contact-info">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h2 className="font-heading text-3xl font-semibold text-[#0B1D3A]">Contact Information</h2>
          <p className="text-slate-500 text-sm">Shown on the Contact page and in the footer. Optional fields stay hidden while empty.</p>
        </div>
        <button onClick={save} disabled={saving} data-testid="admin-contact-save" className="inline-flex items-center gap-1.5 px-5 py-2 rounded-lg bg-[#0B1D3A] text-amber-300 text-sm font-semibold disabled:opacity-60">
          <Save className="w-4 h-4" /> {saving ? "Saving…" : "Save"}
        </button>
      </div>

      <div className="bg-white border border-slate-200 rounded-xl p-6 grid sm:grid-cols-2 gap-4 max-w-3xl">
        <label className="block">
          <span className="block text-xs font-semibold text-slate-600 mb-1">Your name</span>
          <input value={c.advisorName} onChange={(e) => setC({ ...c, advisorName: e.target.value })} className={inputCls} data-testid="contact-field-name" />
        </label>
        <label className="block">
          <span className="block text-xs font-semibold text-slate-600 mb-1">Title</span>
          <input value={c.title} onChange={(e) => setC({ ...c, title: e.target.value })} className={inputCls} data-testid="contact-field-title" />
        </label>
        <label className="block">
          <span className="block text-xs font-semibold text-slate-600 mb-1">Florida registration number</span>
          <input value={c.registration} onChange={(e) => setC({ ...c, registration: e.target.value })} className={inputCls} data-testid="contact-field-registration" />
        </label>
        <label className="block">
          <span className="block text-xs font-semibold text-slate-600 mb-1">Email (public)</span>
          <input value={c.email} onChange={(e) => setC({ ...c, email: e.target.value })} className={inputCls} data-testid="contact-field-email" />
        </label>
        <label className="block">
          <span className="block text-xs font-semibold text-slate-600 mb-1">Phone (optional — hidden while empty)</span>
          <input value={c.phone} onChange={(e) => setC({ ...c, phone: e.target.value })} className={inputCls} data-testid="contact-field-phone" placeholder="Add when ready" />
        </label>
        <label className="block">
          <span className="block text-xs font-semibold text-slate-600 mb-1">Business address (optional — hidden while empty)</span>
          <input value={c.address} onChange={(e) => setC({ ...c, address: e.target.value })} className={inputCls} data-testid="contact-field-address" placeholder="Add when ready" />
        </label>
      </div>
    </div>
  );
}
